import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import '@fancyapps/fancybox';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

var $imageCarousel = $( '.image-carousel' ).flickity( {
	bgLazyLoad: 2,
	pageDots: true,
	prevNextButtons: true,
	selectedAttraction: 0.01,
	friction: 0.2,
	wrapAround: true,
	arrowShape: {
		x0: 20,
		x1: 60, y1: 40,
		x2: 70, y2: 40,
		x3: 30
	}
} );

$imageCarousel.on( 'change.flickity', function( event, index ) {
	var $this = $( this );

	var $textCarousel = $( $this.attr( 'data-text-carousel' ) );

	if ( $textCarousel ) {
		$textCarousel.flickity( 'select', index );
	}

	var $enlarge = $( $this.attr( 'data-enlarge' ) );

	$enlarge.attr( 'href', $this.find( '.carousel-cell' ).eq( index ).attr( 'data-image' ) );
} );

var $textCarousel = $( '.text-carousel' ).flickity( {
	pageDots: false,
	prevNextButtons: false,
	draggable: false,
	wrapAround: true
} );

var $headerImageCarousel = $( '.header-image-carousel' ).flickity( {
	bgLazyLoad: 2,
	pageDots: true,
	prevNextButtons: true,
	selectedAttraction: 0.01,
	friction: 0.2,
	wrapAround: true,
	arrowShape: {
		x0: 20,
		x1: 60, y1: 40,
		x2: 70, y2: 40,
		x3: 30
	}
} );

$headerImageCarousel.on( 'change.flickity', function( event, index ) {
	var $this = $( this );

	var $enlarge = $( $this.attr( 'data-enlarge' ) );

	$enlarge.attr( 'href', $this.find( '.carousel-cell' ).eq( index ).attr( 'data-image' ) );

	var uiTheme = $this.find( '.carousel-cell' ).eq( index ).attr( 'data-ui-theme' );
	if ( uiTheme ) {
		$( '.header-image-carousel-container' ).attr( 'data-ui-theme', uiTheme );
	}
} );

$( '.header-image-carousel .carousel-cell' ).each( function( index ) {
	var $this = $( this );

	var image = $this.attr( 'data-image' );

	isItDark( image, function( darkornot ) {
		$this.attr( 'data-ui-theme', (darkornot) ? 'light' : 'dark' );

		if ( index === 0 ) {
			$( '.header-image-carousel-container' ).attr( 'data-ui-theme', (darkornot) ? 'light' : 'dark' );
		}
	} );
} );

$( window ).resize( function() {
	setTimeout( function() {
		$imageCarousel.flickity( 'reposition' );
		$headerImageCarousel.flickity( 'reposition' );
	}, 100 );
} );


function isItDark( imageSrc, callback ) {
	var fuzzy = 0.1;
	var img = document.createElement( "img" );
	img.src = imageSrc;
	img.style.display = "none";
	document.body.appendChild( img );

	img.onload = function() {
		// create canvas
		var canvas = document.createElement( "canvas" );
		canvas.width = this.width;
		canvas.height = this.height;

		var ctx = canvas.getContext( "2d" );
		ctx.drawImage( this, 0, 0 );

		var imageData = ctx.getImageData( 0, 0, canvas.width, canvas.height );
		var data = imageData.data;
		var r, g, b, max_rgb;
		var light = 0, dark = 0;

		for ( var x = 0, len = data.length; x < len; x += 4 ) {
			r = data[ x ];
			g = data[ x + 1 ];
			b = data[ x + 2 ];

			max_rgb = Math.max( Math.max( r, g ), b );
			if ( max_rgb < 128 )
				dark++;
			else
				light++;
		}

		var dl_diff = ((light - dark) / (this.width * this.height));
		if ( dl_diff + fuzzy < 0 )
			callback( true ); /* Dark. */
		else
			callback( false );  /* Not dark. */
	}
}
